import React, { FC } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { TableHead, TableRow, TableCell } from 'transfix-ui/components/Table'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import Box from 'transfix-ui/core/Box'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'

interface IHeader {
  title: string
  subtitle?: string
  alignRight?: boolean
  tooltipMessage?: string
  dataTest: string
}

const useStyles = makeStyles({
  tableRow: {
    verticalAlign: 'bottom',
    padding: '8px',
  },
})

const headers: IHeader[] = [
  {
    title: 'Equipment',
    dataTest: 'equipment',
  },
  {
    title: 'Cost Assumption',
    subtitle: 'TCM 50 / Market Rate',
    dataTest: 'cost-assumption',
    alignRight: true,
  },
  {
    title: 'Strike Price',
    subtitle: "Model's Expected",
    dataTest: 'strike-price',
    alignRight: true,
  },
  {
    title: 'Margin %',
    subtitle: "Model's Expected",
    dataTest: 'margin-percentage',
    alignRight: true,
  },
  {
    title: 'Win %',
    subtitle: "Model's Expected",
    dataTest: 'win-percentage',
    alignRight: true,
  },
  {
    title: 'Override',
    dataTest: 'override',
    tooltipMessage: 'Overrides are applied to the cost basis of a shipment (TCM50)',
  },
  {
    title: 'Date Range',
    dataTest: 'override-date-range',
  },
  {
    title: 'Reason for Override',
    dataTest: 'override-reason',
  },
  {
    title: '',
    dataTest: 'actions',
  },
]

export const StrikePriceTableHeader: FC = () => {
  const classes = useStyles()
  return (
    <TableHead>
      <TableRow tableCellType='th' className={classes.tableRow}>
        {headers.map(header => (
          <TableCell
            tableCellType='th'
            key={header.dataTest}
            dataTest={`${header.dataTest}-column-header`}>
            {header.subtitle && (
              <Box textAlign={header.alignRight ? 'right' : 'left'} marginBottom='2px'>
                {header.subtitle}
              </Box>
            )}
            <Box
              display='flex'
              flexDirection={header.alignRight ? 'row-reverse' : 'row'}
              color={brandColors.coolGray6}>
              {header.title}
              {header.tooltipMessage && (
                <Tooltip
                  position='bottom'
                  trigger={
                    <Box ml={1} display='flex' alignItems='end'>
                      <InfoIcon size='medium' />
                    </Box>
                  }>
                  {header.tooltipMessage}
                </Tooltip>
              )}
            </Box>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
